export const getFileNameFromSasUrl = (sasUrl: string) => {
  if (!sasUrl) return '';
  // Remove query string
  const urlWithoutQuery = sasUrl.split('?')[0];
  // Split path and get last non-empty segment (handles trailing slashes)
  const segments = urlWithoutQuery.split('/');
  for (let i = segments.length - 1; i >= 0; i--) {
    const seg = segments[i];
    if (seg && seg.length > 0) return decodeURIComponent(seg);
  }
  return '';
}

export const getBase64UriFromBuffer = (base64String: string, contentType: string) => {
  return `data:${contentType};base64,${base64String}`
}

export const getRawBase64FromBase64Uri = (base64Uri: string) => {
  return base64Uri.replace(/^data:.*;base64,/, '');
}

export const getContentTypeFromSasUrl = (sasUrl: string) => {
  if (!sasUrl) return '';
  // Extract file extension from URL (before query params)
  const urlWithoutQuery = sasUrl.split('?')[0];
  const extension = urlWithoutQuery?.split('.')?.pop()?.toLowerCase();

  // Map common extensions to content types
  const extToContentType: any = {
    'pdf': 'application/pdf',
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'png': 'image/png',
    'gif': 'image/gif',
    'doc': 'application/msword',
    'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'xls': 'application/vnd.ms-excel',
    'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'txt': 'text/plain',
    'zip': 'application/zip',
  };

  return extension?extToContentType[extension]:'';
}
